module.exports = __webpack_public_path__ + "img/face-grin-beam-sweat.77ae5240.svg";